var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductAutoComplete',_vm._g({attrs:{"value":_vm.value,"forceSelection":_vm.forceSelection,"verified":true}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }